export default "__VITE_ASSET__8c15aba4__"